import React, { useCallback, FC } from 'react'
import label from 'styles/components/label.module.scss'
import styles from 'styles/components/tab.module.scss'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { Spacer } from 'components/Utility'
import { selectTopTab } from 'reducks/auth/operations'
import { getTopTab } from 'reducks/auth/selectors'
import { usePreparingShippingCount } from 'hooks/shipping'

const TopTabs: FC = React.memo(() => {
  const dispatch = useDispatch()
  const topTab = useSelector((state: State) => getTopTab(state))
  const selectHandOverTab = useCallback(() => dispatch(selectTopTab('hand_over')), [])
  const selectDeliveryTab = useCallback(() => dispatch(selectTopTab('delivery')), [])

  const { count: preparingShippingAmount, loading } = usePreparingShippingCount(7)

  return (
    <section className={styles.topTabs}>
      <div className={styles.topTabs__inner}>
        <button
          className={classNames(styles.topTab, { [styles.topTab_active]: topTab === 'hand_over' })}
          disabled={topTab === 'hand_over'}
          onClick={selectHandOverTab}
        >
          <span>お店でお渡し</span>
        </button>
        <Spacer size={4} />
        <button
          className={classNames(styles.topTab, { [styles.topTab_active]: topTab === 'delivery' })}
          disabled={topTab === 'delivery'}
          onClick={selectDeliveryTab}
        >
          <span>お取り寄せ</span>
          {!loading && preparingShippingAmount > 0 && (
            <>
              <Spacer size={4} />
              <span className={label.unshipped}>未発送{preparingShippingAmount}件</span>
            </>
          )}
        </button>
      </div>
    </section>
  )
})

export default TopTabs
